import React, { useState } from 'react';
import Image from "next/image";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
// @mui/icons-material
import PinDrop from "@mui/icons-material/PinDrop";
import Phone from "@mui/icons-material/Phone";
import Check from "@mui/icons-material/Check";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import axios from 'axios';


import styles from "./HomeCommon.module.scss";

const RegularMap = () => {
  const mapRef = React.useRef(null);
  React.useEffect(() => {
    let google = window.google;
    let map = mapRef.current;
    let lat = "44.43353";
    let lng = "26.093928";
    const myLatlng = new google.maps.LatLng(lat, lng);
    const mapOptions = {
      zoom: 14,
      center: myLatlng,
      scrollwheel: false,
      zoomControl: true,
      styles: [
        {
          featureType: "water",
          stylers: [{ saturation: 43 }, { lightness: -11 }, { hue: "#0088ff" }],
        },
        {
          featureType: "road",
          elementType: "geometry.fill",
          stylers: [
            { hue: "#ff0000" },
            { saturation: -100 },
            { lightness: 99 },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [{ color: "#808080" }, { lightness: 54 }],
        },
        {
          featureType: "landscape.man_made",
          elementType: "geometry.fill",
          stylers: [{ color: "#ece2d9" }],
        },
        {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [{ color: "#ccdca1" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{ color: "#767676" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.stroke",
          stylers: [{ color: "#ffffff" }],
        },
        { featureType: "poi", stylers: [{ visibility: "off" }] },
        {
          featureType: "landscape.natural",
          elementType: "geometry.fill",
          stylers: [{ visibility: "on" }, { color: "#b8cb93" }],
        },
        { featureType: "poi.park", stylers: [{ visibility: "on" }] },
        {
          featureType: "poi.sports_complex",
          stylers: [{ visibility: "on" }],
        },
        { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
        {
          featureType: "poi.business",
          stylers: [{ visibility: "simplified" }],
        },
      ],
    };

    map = new google.maps.Map(map, mapOptions);

    const marker = new google.maps.Marker({
      position: myLatlng,
      map: map,
      animation: google.maps.Animation.DROP,
      title: "NextJS Material Kit PRO!",
    });

    const contentString =
      '<div class="info-window-content"><h2>NextJS Material Kit PRO</h2>' +
      "<p>A premium Admin for React, Material-UI, and React Hooks.</p></div>";

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });

    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  });
  return (
    <>
      <div
        style={{
          height: `100%`,
          borderRadius: "6px",
          overflow: "hidden",
        }}
        ref={mapRef}
      ></div>
    </>
  );
};



export default function SectionContacts({ ...rest }) {
  const [checked, setChecked] = React.useState([]);
  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

    {/* New Form Functions */}
    const [status, setStatus] = useState({
      submitted: false,
      submitting: false,
      info: { error: false, msg: null },
    });
    const [inputs, setInputs] = useState({
      email: '',
      message: '',
    });
    const handleServerResponse = (ok, msg) => {
      if (ok) {
        setStatus({
          submitted: true,
          submitting: false,
          info: { error: false, msg: msg },
        });
        setInputs({
          email: '',
          message: '',
        });
      } else {
        setStatus({
          info: { error: true, msg: msg },
        });
      }
    };
    const handleOnChange = (e) => {
      e.persist();
      setInputs((prev) => ({
        ...prev,
        [e.target.id]: e.target.value,
      }));
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: false, msg: null },
      });
    };
    const handleOnSubmit = (e) => {
      e.preventDefault();
      setStatus((prevStatus) => ({ ...prevStatus, submitting: true }));
      axios({
        method: 'POST',
        url: 'https://formspree.io/f/mvodqwqo',
        data: inputs,
      })
        .then((response) => {
          handleServerResponse(
            true,
            'Thank you, your message has been submitted.',
          );
        })
        .catch((error) => {
          handleServerResponse(false, error.response.data.error);
        });
    };


  return (


    
    <div className="cd-section" {...rest}>



      {/* Contact us 1 START */}
      <div className={`${styles.contacts} ${styles.sectionOverlay}`}>
          <Image
        
        layout="fill"
        objectFit ="cover"
        src ={"/img/sections/services/all-services/melbourne-sm.webp"}
        alt=".."
        />
        <div className={styles.container}>
        <GridContainer sx={{jusifyContent:{xs: "center", md:"space-between"}}}>
            <GridItem xs={12} sm={5} md={5}>
              <h2 className={styles.title}>Get in Touch</h2>
              <h5 className={styles.description}>
              Hey there, we'd love to hear from you!
              </h5>
              <InfoArea
                className={styles.infoArea}
                title="Find us at the office"
                description={
                  <>
                    <span>Lvl 1, 25 King Street</span>
                    <br /> 
                    <span>3000, Melbourne, VIC</span>
                    <br /> 
                    <span>Australia</span>
                  </>
                }
                icon={PinDrop}
              />
              <InfoArea
                className={styles.infoArea}
                title="Give us a ring"
                description={
                  <>
                    <span>Tribalism Team</span>
                    <br /> 
                    <span>+61 1300 151 387</span>
                    <br />
                    <span>Mon - Fri, 9:00-17:00</span>
                  </>
                }
                icon={Phone}
              />
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={styles.mlAuto}>
              <Card className={styles.card1}>
              <form onSubmit={handleOnSubmit}>
                  <CardHeader
                    contact
                    color="rose"
                    className={styles.textCenter}
                  >
                    <h4 className={styles.cardTitle} style={{ color: 'white' }}>Contact Us</h4>
                  </CardHeader>
                  <CardBody>
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText="First Name"
                          id="first"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            onChange: handleOnChange,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText="Last Name"
                          id="last"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            onChange: handleOnChange,
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                    <CustomInput
                      labelText="Email Address"
                      id="email-address"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: handleOnChange,
                      }}
                    />
                    <CustomInput
                      labelText="Your Message"
                      id="message"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 5,
                        onChange: handleOnChange
                      }}
                    />
                  </CardBody>
                  <CardFooter className={styles.justifyContentBetween}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          tabIndex={-1}
                          onClick={() => handleToggle(1)}
                          checkedIcon={
                            <Check className={styles.checkedIcon} />
                          }
                          icon={<Check className={styles.uncheckedIcon} />}
                          classes={{
                            checked: styles.checked,
                            root: styles.checkRoot,
                          }}
                        />
                      }
                      classes={{ label: styles.label }}
                      label="I'm not a robot"
                    />

                    <Button color="rose" className={styles.pullRight} type="submit" disabled={status.submitting} onClick={() => {!status.submitting ? !status.submitted ? 'Submit' : 'Submitted' : 'Submitting...'}}>
                      Send Message 
                    </Button>

                  </CardFooter>
                </form>
                {status.info.error && (
                  <div className="error">Error: {status.info.msg}</div>
                )}
                {!status.info.error && status.info.msg && <p>{status.info.msg}</p>}
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      {/* Contact us 1 END */}

    </div>
  );
}
